import React, { useContext, useEffect, useState, useRef } from "react";
import AppContext from "../../../context/AppContext";
import { fetchData, getWorkflows } from "../../../service/workflow";
import classNames from "classnames";
import translations from "../Translations";
import ReactSelector from "../CommonReactSelector";
import { components } from 'react-select';
import { fetchTasks } from "../../../service/Task";
import { Spinner } from "../../../Spinner";
const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

const ActivitySelect = ({ setWorkflowName, showPlaceholder=false, placeholder="", optionData=[], height="auto", classname, defaultValue }) => {
  const [data, setData] = useState([]);
  const { setWorkflowId, userType, selectedOption, setSelectedOption,setTaskData ,setTotalPageSize, updateActivityId, projectId} = useContext(AppContext);
  const { theme, langMode } = useContext(AppContext);

  // const [selectedActivityName, setSelectedActivityName] = useState("");
  const selectRef = useRef(null);
    // const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedOption = localStorage.getItem("selectedActivity");
    if (storedOption) {
      setSelectedOption(storedOption);
      setWorkflowId(storedOption);
    }
  }, []); // Empty dependency to run only once

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getWorkflows(projectId, userType);
        const workflows = response.body.value;
        if (Array.isArray(workflows)) {
          setData(workflows);
          const workflowMap = workflows.reduce((map, workflow) => {
            map[workflow.workflowId] = workflow.workflowName;
            return map;
          }, {});
          // setWorkflowName(workflowMap);

          const selectedWorkflow = workflows.find(
            (workflow) => workflow.workflowId === selectedOption
          );
          // setSelectedActivityName(
          //   selectedWorkflow ? selectedWorkflow.workflowName : ""
          // );
        } else {
          console.error("Expected an array but got:", workflows);
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching workflows:", error);
      }
    };
    if (projectId) fetchData();

  }, [projectId]);

  const handleOptionChange = (event) => {
    const workflowId = event.target.value;
    setSelectedOption(workflowId);
    setWorkflowId(workflowId);
    localStorage.setItem("selectedActivity", workflowId);

    // const selectedWorkflow = data.find(
    //   (workflow) => workflow.workflowId === workflowId
    // );
    // setSelectedActivityName(
    //   selectedWorkflow ? selectedWorkflow.workflowName : ""
    // );
  };
  

  const handleChangeActivity = async(selectedValue) => {

    const data = await fetchTasks({workflowIds: selectedValue.value, priority:"Priority", active:"Status",currentPage:0,pageSize:10 });
    setTaskData(data?.taskList)
    setWorkflowId(selectedValue?.value)
    setTotalPageSize(data?.totalSize)
    updateActivityId(selectedValue.value)
    setWorkflowName(selectedValue?.label)
  }

  const options = (optionData || data)?.map((item) => ({ "value": item.workflowId, "label": item.workflowName }))
   useEffect(() => {
     if (defaultValue && defaultValue.length > 0) {
       const valueString = defaultValue.map(item => item.value).join(',');
        setWorkflowId(valueString);
        // updateActivityId(valueString);
      }
    }, [defaultValue]);

  return (
    <>
    {/* {
      loading ? <Spinner />
      : */}
      <div className={`w-full flex items-center gap-2 ${classname || ''}`}>

        <div className={`w-[219px] border border-[#00000066] bg-[#D3E2F0] text-[#00000066 rounded-[24px]`}>
          <ReactSelector
            options={options}
            height={height}
            components={showPlaceholder ? Placeholder : {}}
            placeholder={placeholder}
            onChange={handleChangeActivity}
            isClearable={false}
            value={defaultValue} // Add this line to control the value
            borderRadius={"24px"}
            background={"#D3E2F0"}
          />
        </div>
      </div>
    </>
  );
};

export default ActivitySelect;
